import { useNavigate } from "react-router-dom";
import { useUserPoints } from "@/hooks/useUserPoints";

export default function PointsBadge() {
  const { balance, loading } = useUserPoints();
  const navigate = useNavigate();
  if (loading) return null;
  return (
    <button
      type="button"
      onClick={() => navigate("/billing")}
      className="inline-flex items-center justify-center gap-1 px-2.5 py-1 text-xs font-stat text-[hsl(var(--tertiary))] hover:bg-accent hover:brightness-110 transition-all min-h-[44px] min-w-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--tertiary))]"
      title={`${balance} mérite${balance > 1 ? "s" : ""}`}
    >
      <span className="text-[11px]">⚡</span>
      {balance}
    </button>
  );
}
